import { useTranslation } from '../i18n/useTranslation';
import styles from './SettingsPage.module.css';
import { Heading, Select, Stack } from '../components/atoms';
import { AppLayout } from '../components/templates/AppLayout/AppLayout';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/Sidebar';
import { PageContent } from '../components/templates/PageContent/PageContent';
import { PageHeader } from '../components/templates/PageHeader/PageHeader';
import { Section } from '../components/templates/Section/Section';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useTheme } from '../theme/useTheme';
import { AiUsageMeter } from '../components/aiUsage/AiUsageMeter';
import { AccountSection } from '../components/settings/AccountSection';
import { DataExportSection } from '../components/settings/DataExportSection';
import { DeleteAccountSection } from '../components/settings/DeleteAccountSection';
import { EmailNotificationsSection } from '../components/settings/EmailNotificationsSection';
import { TwoFactorSection } from '../components/settings/TwoFactorSection';
import { OnboardingSettingsSection } from '../components/onboarding/OnboardingSettingsSection';
import { AppVersion } from '../components/about/AppVersion';
import { CurrencySetting } from '../components/settings/CurrencySetting';
import { DashboardCardsSection } from '../components/settings/DashboardCardsSection';
import { OptInPromptsSection } from '../components/optInPrompts/OptInPromptsSection';
import { VoiceNotesSection } from '../components/settings/VoiceNotesSection';

export function SettingsPage() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <AppLayout
      header={<Header />}
      sidebar={<Sidebar />}
      main={
        <PageContent width="narrow">
          <PageHeader title={t('settings.title')} description={t('settings.subtitle')} />

          <Section title={t('settings.general')} className={styles.section}>
            <Stack gap="3">
              <Heading level={3}>{t('settings.language.title')}</Heading>
              <LanguageSwitcher />
            </Stack>

            <Stack gap="3">
              <Heading level={3}>{t('settings.theme')}</Heading>
              <Select
                value={theme}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === 'light' || val === 'dark') setTheme(val);
                }}
                aria-label={t('settings.theme')}
              >
                <option value="light">{t('settings.themeLight')}</option>
                <option value="dark">{t('settings.themeDark')}</option>
              </Select>
            </Stack>

            <CurrencySetting />
          </Section>

          <DashboardCardsSection className={styles.section} />

          <EmailNotificationsSection className={styles.section} />

          <OptInPromptsSection className={styles.section} />

          <VoiceNotesSection className={styles.section} />

          <OnboardingSettingsSection className={styles.section} />

          <Section title={t('aiUsage.title')} className={styles.section}>
            <AiUsageMeter variant="full" />
          </Section>

          <AccountSection className={styles.section} />

          <TwoFactorSection className={styles.section} />

          <DataExportSection className={styles.section} />

          <DeleteAccountSection className={styles.section} />

          <Section title={t('settings.about.title')} className={styles.section}>
            <AppVersion size="sm" />
          </Section>

        </PageContent>
      }
    />
  );
}

export default SettingsPage;
